import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-2 items-center" }
const _hoisted_2 = ["tabindex"]
const _hoisted_3 = ["src"]

import { ref, reactive } from 'vue'
import AudioPlay from '@/assets/svg/AudioPlay.vue'
import AudioProgress from './AudioProgress.vue'
import type { Ref } from 'vue'
import AudioPause from '@/assets/svg/AudioPause.vue'
import { useEventBus } from '@vueuse/core'

interface Props {
  src: string
  tabindex?: number
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'AudioPlayer',
  props: {
    src: null,
    tabindex: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  src: string
  tabindex?: number
}


const audioElement: Ref<HTMLAudioElement | null> = ref(null)
const setAudioDuckedBus = useEventBus('set-audio-ducked')
const state = reactive({
  progress: 0,
  elapsedTime: '0:00',
  isPlaying: false,
})

const togglePlayPause = (evt) => {
  if (audioElement.value?.paused) {
    audioElement.value?.play()
  } else {
    audioElement.value?.pause()
  }
  evt.stopPropagation()
}

const play = () => {
  audioElement.value?.play()
}

const pause = () => {
  audioElement.value?.pause()
}

const handlePlay = (evt) => {
  state.isPlaying = true
  setAudioDuckedBus.emit(true)
}

const handlePause = (evt) => {
  state.isPlaying = false
  setAudioDuckedBus.emit(false)
}

expose({ play, pause })

const handleTimeUpdate = (evt) => {
  if (audioElement.value) {
    const currentTime = audioElement.value?.currentTime
    state.progress = currentTime / audioElement.value.duration
    const minutes = Math.floor(currentTime / 60.0)
    const seconds = Math.floor(currentTime) % 60
    const secondsAsString = seconds < 10 ? '0' + seconds : seconds
    state.elapsedTime = minutes + ':' + secondsAsString
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      tabindex: props.tabindex,
      onClick: togglePlayPause
    }, [
      (!state.isPlaying)
        ? (_openBlock(), _createBlock(AudioPlay, { key: 0 }))
        : _createCommentVNode("", true),
      (state.isPlaying)
        ? (_openBlock(), _createBlock(AudioPause, { key: 1 }))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    _createVNode(AudioProgress, {
      class: "flex-grow",
      progress: state.progress
    }, null, 8, ["progress"]),
    _createElementVNode("audio", {
      ref_key: "audioElement",
      ref: audioElement,
      class: "hidden",
      onTimeupdate: handleTimeUpdate,
      onPlay: handlePlay,
      onPause: handlePause
    }, [
      _createElementVNode("source", {
        src: props.src,
        type: "audio/mpeg"
      }, null, 8, _hoisted_3)
    ], 544),
    _createElementVNode("span", null, _toDisplayString(state.elapsedTime), 1)
  ]))
}
}

})